import {
    getBaseColorHex,
    GraphBaseColor,
} from "~/utilities/analytics/graphColors";

/** Conversion % line — shared across Performance tabs (Figma). */
export const EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR = getBaseColorHex(GraphBaseColor.softTerracotta);

/**
 * Primary + secondary series colors per Performance tab (Event-wise performance trends).
 * Matches Emotorad dashboard Figma: Leads / Calls / Walk-ins / Test Ride / Sales.
 */
export const EMOTORAD_DASHBOARD_TABBED_LINE_CHART_SERIES_COLORS: Record<
    string,
    {primary: string; secondary: string}
> = {
    leads: {
        primary: getBaseColorHex(GraphBaseColor.corporateBlue),
        secondary: EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR,
    },
    calls: {
        primary: getBaseColorHex(GraphBaseColor.skyTeal),
        secondary: EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR,
    },
    "walk-ins": {
        primary: getBaseColorHex(GraphBaseColor.heatherPurple),
        secondary: EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR,
    },
    "test-ride": {
        primary: getBaseColorHex(GraphBaseColor.dustyCoral),
        secondary: EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR,
    },
    sales: {
        primary: getBaseColorHex(GraphBaseColor.jadeEmerald),
        secondary: EMOTORAD_DASHBOARD_CONVERSION_PERCENT_COLOR,
    },
};

/** Drop-off & Conversion Funnel Tracker gradient base. */
export const EMOTORAD_DASHBOARD_FUNNEL_BASE_COLOR = GraphBaseColor.corporateBlue;

/** Distance-based Lead Distribution bar fill. */
export const EMOTORAD_DASHBOARD_DISTANCE_BAR_COLOR = getBaseColorHex(GraphBaseColor.corporateBlue);

/** Disposition Analysis donut slice order. */
export const EMOTORAD_DASHBOARD_DONUT_SLICE_COLORS: ReadonlyArray<string> = [
    getBaseColorHex(GraphBaseColor.corporateBlue),
    getBaseColorHex(GraphBaseColor.skyTeal),
    getBaseColorHex(GraphBaseColor.heatherPurple),
    getBaseColorHex(GraphBaseColor.dustyCoral),
    getBaseColorHex(GraphBaseColor.jadeEmerald),
    getBaseColorHex(GraphBaseColor.softTerracotta),
    getBaseColorHex(GraphBaseColor.periwinkle),
    getBaseColorHex(GraphBaseColor.mutedRose),
    getBaseColorHex(GraphBaseColor.deepMoss),
    getBaseColorHex(GraphBaseColor.neutral),
];
